export default "__VITE_ASSET__BFhCLVEA__"